import React from 'react';

// Tela-padrão para módulos que ainda não estão liberados (mesmo visual das
// telas "Em elaboração" já existentes, ex.: UploadOrcamentos).
export default function TelaEmManutencao({ icone = '🛠️', titulo, descricao, etiqueta = 'Em manutenção' }) {
  return (
    <div style={{ padding: '48px 32px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 420 }}>
      <div style={{ fontSize: 56, marginBottom: 16 }}>{icone}</div>
      <div style={{ display: 'inline-block', background: '#fef9c3', color: '#a16207', padding: '4px 14px', borderRadius: 20, fontSize: '0.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: .6, marginBottom: 14 }}>{etiqueta}</div>
      <div style={{ fontWeight: 800, fontSize: '1.3rem', color: '#1e293b', marginBottom: 8, textAlign: 'center' }}>{titulo}</div>
      <div style={{ color: '#64748b', fontSize: '0.88rem', textAlign: 'center', maxWidth: 480, lineHeight: 1.6 }}>
        {descricao || 'Esta funcionalidade está em manutenção e será disponibilizada em breve.'}
      </div>
    </div>
  );
}
